import router from 'routers/analytics.router';
import {setupAjaxConfiguration} from "ajaxSetup";

require('traits/google-analytics');

setupAjaxConfiguration(router, undefined, (xhr) => {
    if (xhr.getResponseHeader("isPostpaid") === "true") {
        $("#geo-tile").remove();
    } else {
        $("#geo-tile").show();
    }
}).then(() => console.log("Ajax setup done."));
